var tabCustomBo = {
    label: '',
    content: null
};

export default tabCustomBo;


// WEBPACK FOOTER //
// ./src/components/custom/tabs/TabCustomData.js